export default __webpack_public_path__ + "static/media/Vector.393af72b.svg";